import createIcon from '../../createIcon';

/**
 * @component @name VerticalAlignBottom
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYgMTNIMTNWM0gxMVYxM0g4TDEyIDE3TDE2IDEzWk00IDE5VjIxSDIwVjE5SDRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const VerticalAlignBottom = createIcon('VerticalAlignBottom', [
  ['path', { d: 'M16 13H13V3H11V13H8L12 17L16 13ZM4 19V21H20V19H4Z', key: '1igi80' }],
]);

export default VerticalAlignBottom;
